import { CompanyDetailReviewCategory } from "@/api/types";

export const CATEGORY_NAME = {
  [CompanyDetailReviewCategory.SEMINAR]: "説明会",
  [CompanyDetailReviewCategory.INTERN]: "インターン",
  [CompanyDetailReviewCategory.RECRUITMENT]: "本選考"
  // TODO: ENTRY_SHEET の項目は今後対応
  // [CompanyDetailReviewCategory.ENTRY_SHEET]: "エントリーシート設問"
} as const;

export const INIT_REVIEW = [
  {
    category: CompanyDetailReviewCategory.SEMINAR,
    name: CATEGORY_NAME[CompanyDetailReviewCategory.SEMINAR]
  },
  {
    category: CompanyDetailReviewCategory.INTERN,
    name: CATEGORY_NAME[CompanyDetailReviewCategory.INTERN]
  },
  {
    category: CompanyDetailReviewCategory.RECRUITMENT,
    name: CATEGORY_NAME[CompanyDetailReviewCategory.RECRUITMENT]
  }
  // TODO: ENTRY_SHEET の項目は今後対応
  // {
  //   category: CompanyDetailReviewCategory.ENTRY_SHEET,
  //   name: CATEGORY_NAME[CompanyDetailReviewCategory.ENTRY_SHEET]
  // }
] as const;

// NOTE: レーダーチャートにENTRY_SHEETは存在しない。
export const INIT_REVIEW_RADAR_CART = [
  {
    category: CompanyDetailReviewCategory.SEMINAR,
    name: CATEGORY_NAME[CompanyDetailReviewCategory.SEMINAR]
  },
  {
    category: CompanyDetailReviewCategory.INTERN,
    name: CATEGORY_NAME[CompanyDetailReviewCategory.INTERN]
  },
  {
    category: CompanyDetailReviewCategory.RECRUITMENT,
    name: CATEGORY_NAME[CompanyDetailReviewCategory.RECRUITMENT]
  }
] as const;

export const BUSINESS_CATEGORY_OPTIONS = [
  {
    label: "指定なし",
    value: ""
  },
  {
    label: "コンサル・シンクタンク",
    value: "コンサル・シンクタンク"
  },
  {
    label: "金融",
    value: "金融"
  },
  {
    label: "メーカー",
    value: "メーカー"
  },
  {
    label: "商社",
    value: "商社"
  },
  {
    label: "IT・通信",
    value: "IT・通信"
  },
  {
    label: "広告・マスコミ",
    value: "広告・マスコミ"
  },
  {
    label: "人材・教育",
    value: "人材・教育"
  },
  {
    label: "インフラ・交通",
    value: "インフラ・交通"
  },
  {
    label: "不動産・建設",
    value: "不動産・建設"
  },
  {
    label: "旅行・観光",
    value: "旅行・観光"
  },
  {
    label: "ブライダル・美容・くらし",
    value: "ブライダル・美容・くらし"
  },
  {
    label: "医療・福祉",
    value: "医療・福祉"
  },
  {
    label: "小売・流通",
    value: "小売・流通"
  },
  {
    label: "公務員・団体職員",
    value: "公務員・団体職員"
  },
  {
    label: "その他",
    value: "その他"
  }
] as const;

export const BUSINESS_CATEGORY = BUSINESS_CATEGORY_OPTIONS.filter(
  category => category.value !== ""
);
